import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Parallax } from "react-parallax";
import { Link, useNavigate } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import useLocalStorage from "use-local-storage";
// import useAuth from "../../hooks/useAuth";

import Navbar from '../layout/Navbar';
import Preloader from '../layout/preloader';
import Footer from '../section-pages/footer';
import ScrollToTopBtn from '../layout/ScrollToTop';
import { handleLogin } from '../api';
import { siteName } from '../main';

const NavLink = (props) => {
  return <Link {...props} />;
};

const image1 = "./img/background/2.webp";

const GlobalStyles = createGlobalStyle`
  .react-parallax-bgimage {
    transform: translate3d(-50%, 0, 0px) !important;
  }
  .h-100{
    height: 100vh !important;
  }
`;

export default function Home() {
  const navigate = useNavigate();
  // const { signIn } = useAuth();
  const [myStore, setMyStore] = useLocalStorage("name", {});
  const [loading, setLoading] = useState(false);


  const { myInfo } = myStore;

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const loader = document.getElementById('mainpreloader');
      if (loader)
        setTimeout(() => {
          loader.classList.add("fadeOut");
          loader.style.display = 'none';
        }, 600)
    }
  }, []);

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Must be a valid email").required("Email is required"),
      password: Yup.string().required("Password is required"),
    }),
    onSubmit: async (values, { setErrors, setStatus, setSubmitting }) => {
      setLoading(true)
      try {
        if (!siteName) {
          alert('Site name not approved my admin for your use')
        }
        const res = await signIn({
          email: values.email,
          password: values.password,
          resource: `vare_user_${siteName}`
        }); //todo
        if (res?.token) {
          setMyStore({ ...myStore, myInfo: res });
          setTimeout(() => {
            setLoading(false)
            navigate("/");
          }, 300);
        } else {
          alert(res?.message || "Login failed. Please verify your username and password and try again.");
        }
      } catch (error) {
        const message = error.message || "Something went wrong";
        setStatus({ success: false });
        setErrors({ submit: message });
        setSubmitting(false);
      }
    }
  });

  return (
    <>
      {/* HEAD */}
      <Helmet>
        <link rel="icon" href="./img/icon.png" />
        <title>{siteName}</title>
      </Helmet>

      <GlobalStyles />

      {/* LOADER */}
      <div id='mainpreloader'>
        <Preloader />
      </div>

      {/* MENU */}
      <div className="home dark-scheme">
        <header id="header-wrap">
          <Navbar />
        </header>

        {/* section */}
        <Parallax className="" bgImage={image1} strength={5}>
          <div className="de-gradient-edge-top"></div>
          <div className="de-gradient-edge-bottom"></div>
          <section className="no-bg h-100">
            <div className="container z-9 mt100">
              <div className="row align-items-center">
                <div className="col-lg-4 offset-lg-4">
                  <div className="padding40 rounded-10 shadow-soft bg-dark-1" id="login">
                    <div className="text-center">
                      <h4>Sign in to your account</h4>
                    </div>
                    <div className="spacer-10"></div>
                    <form onSubmit={formik.handleSubmit} className="form-border">
                      <div className="field-set">
                        <label>Email</label>
                        <input
                          type='email'
                          name='email'
                          id='email'
                          className="form-control"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.email}
                        />
                        {formik.touched.email && formik.errors.email && (
                          <div style={{ color: 'red' }}>{formik.errors.email}</div>
                        )}
                      </div>
                      <div className="field-set">
                        <label>Password</label>
                        <input
                          type='password'
                          name='password'
                          id='password'
                          className="form-control"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.password}
                        />
                        {formik.touched.password && formik.errors.password && (
                          <div style={{ color: 'red' }}>{formik.errors.password}</div>
                        )}
                      </div>
                      <div className="field-set">
                        <input type="checkbox" id="remember" name="remember" />
                        <label><span className="op-5">&nbsp;Remember me</span></label><br />
                      </div>
                      <div className="spacer-20"></div>
                      <div id="submit">
                        <input
                          type="submit"
                          value={loading ? "loading..." : "Sign In"}
                          className="btn-main btn-fullwidth rounded-3"
                          disabled={formik.isSubmitting}
                        />
                      </div>
                    </form>

                    <div id="submit" style={{
                      marginTop: 40,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <NavLink to="/register" className="btn-line" id="btn-line">
                        Register
                      </NavLink>
                    </div>
                    <div className="title-line">Or&nbsp;login&nbsp;up&nbsp;with</div>
                    <div className="row g-2">
                      <div className="col-lg-6">
                        <Link className="btn-sc btn-fullwidth mb10" to="/"><img src="./img/svg/google_icon.svg" alt="" />Google</Link>
                      </div>
                      <div className="col-lg-6">
                        <Link className="btn-sc btn-fullwidth mb10" to="/"><img src="./img/svg/facebook_icon.svg" alt="" />Facebook</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </Parallax>

        {/* footer */}
        <Footer />
      </div>
      <ScrollToTopBtn />
    </>
  );
}


const signIn = async (props) => {
  return await handleLogin(props).then(res => {
    return res
  })

}